export default function videoWidget(editor) {
  editor.DomComponents.addType('eb-video', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-video'
    },
    model: {
      defaults: {
        name: 'Video',
        tagName: 'div',
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-video' },
        style: {
          'position': 'relative',
          'padding-bottom': '56.25%',
          'height': '0',
          'overflow': 'hidden',
          'border-radius': '8px',
        },
        components: `<iframe style="position:absolute;top:0;left:0;width:100%;height:100%;border:none;" src="https://www.youtube.com/embed/dQw4w9WgXcQ" allowfullscreen></iframe>`,
        traits: [
          { type: 'text', name: 'data-video-url', label: 'Video URL', changeProp: true },
          {
            type: 'select', name: 'data-video-type', label: 'Source',
            options: [
              { id: 'youtube', label: 'YouTube' },
              { id: 'vimeo', label: 'Vimeo' },
              { id: 'self', label: 'Self Hosted' },
            ],
          },
        ],
      },
      init() {
        this.on('change:attributes:data-video-url', this.updateVideo)
      },
      updateVideo() {
        const url = this.getAttributes()['data-video-url'] || ''
        const type = this.getAttributes()['data-video-type'] || 'youtube'
        let embedUrl = url
        if (type === 'youtube') {
          const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/)
          if (match) embedUrl = `https://www.youtube.com/embed/${match[1]}`
        } else if (type === 'vimeo') {
          const match = url.match(/vimeo\.com\/(\d+)/)
          if (match) embedUrl = `https://player.vimeo.com/video/${match[1]}`
        }
        this.components(`<iframe style="position:absolute;top:0;left:0;width:100%;height:100%;border:none;" src="${embedUrl}" allowfullscreen></iframe>`)
      },
    },
  })

  editor.BlockManager.add('eb-video', {
    label: 'Video',
    category: 'Basic',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M10,16.5V7.5L16,12M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"/></svg>',
    content: { type: 'eb-video' },
  })
}
